import React, { Component } from 'react';
import { Alert } from 'reactstrap';
import { ClaimantForm } from './ClaimantForm';
import { LoadingModal } from './LoadingModal';
import { FetchData } from './utils/DataFetch';
import { GetCookie, GetParameterByName } from './utils/Common';
import { NewClaimantModel } from './utils/NewClaimantModel';
import { DecodeLinkPayload, CaseInsensitive } from './utils/LinkPayload';

// Fields the link may not set: the form decides these for a new claimant.
const RESERVED_FIELDS = new Set(['EventType', 'ClmId', 'ClmClaimNumberNoDash', 'CreateDateTime', 'CreatebyUserId', 'UpdateByUserId', 'UpdateDateTime', 'IsDeletedFlg', 'ClientName', 'ClientAbbrv', 'RepFirstName', 'RepLastName']);

// The work-order agent's email links here with a new claimant in ?claimant=, for when the claimant isn't in ELA yet.
export class ClaimantApi extends Component {
  static displayName = ClaimantApi.name;

  constructor(props) {
    super(props);
    this.user = JSON.parse(GetCookie('user'));
    this.state = { model: null, modal: false, fetchingData: false, alert: null };
  }

  componentDidMount() {
    const param = GetParameterByName('claimant');
    if (!param) {
      this.setState({ alert: { color: 'warning', message: 'This link has no claimant data.' } });
      return;
    }

    let request;
    try {
      request = DecodeLinkPayload(param);
    } catch (err) {
      this.setState({ alert: { color: 'danger', message: 'The link from the email is damaged. Ask for a new draft.' } });
      return;
    }
    this.openForm(request);
  }

  async openForm(request) {
    const field = CaseInsensitive(request);
    const model = NewClaimantModel();
    Object.keys(model)
      .filter((key) => !RESERVED_FIELDS.has(key) && field(key) !== undefined && field(key) !== null)
      .forEach((key) => {
        model[key] = field(key);
      });

    this.setState({ fetchingData: true });
    let alert = null;
    try {
      if (model.RepId) {
        const reps = await FetchData('/getreps', 'POST', this.user.token, { RepId: model.RepId });
        const rep = Array.isArray(reps) && reps.length > 0 ? reps[0] : null;
        if (rep) {
          Object.assign(model, {
            RepFirstName: rep.repFirstName,
            RepLastName: rep.repLastName,
            ClientId: rep.clientId,
            ClientName: rep.clientName,
            ClientAbbrv: rep.clientAbbrv,
          });
        } else {
          model.RepId = null;
          alert = { color: 'warning', message: 'Could not find the rep from the email. Pick one in the form.', isOpen: true };
        }
      }
    } catch (err) {
      alert = { color: 'danger', message: 'Could not load the rep for this claimant.', isOpen: true };
    } finally {
      this.setState({ model, modal: true, alert, fetchingData: false });
    }
  }

  // Like /workorderapi, closing the form (ESC or X) lands on the list showing this record.
  setModal = () => {
    this.goToClaimantList(this.state.model?.ClmClaimNumber);
  };

  goToClaimantList(claimNumber) {
    window.location.href = claimNumber ? `/?tab=claimant&claimnumber=${encodeURIComponent(claimNumber)}` : '/?tab=claimant';
  }

  setFetchingData = (fetchingData) => {
    this.setState({ fetchingData });
  };

  // A save that closes the form succeeded; open the Claimant list on the new claimant so the user sees it was created.
  handleSaveEventSuccess = (alert) => {
    if (!alert.modal) {
      this.goToClaimantList(alert.model?.ClmClaimNumber);
      return;
    }
    this.setState({ alert: { color: alert.color, message: alert.message, isOpen: true } });
  };

  render() {
    const { model, modal, fetchingData, alert } = this.state;

    return (
      <div>
        <LoadingModal fetchingData={fetchingData} />
        {alert && !modal && <Alert color={alert.color}>{alert.message}</Alert>}
        {modal && (
          <ClaimantForm
            model={model}
            modal={modal}
            alert={alert || { color: 'success', message: '', isOpen: false }}
            setModal={this.setModal}
            handleSaveEventSuccess={this.handleSaveEventSuccess}
            setFetchingData={this.setFetchingData}
          />
        )}
      </div>
    );
  }
}
